import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import toTsvString from 'utils/toTsvString';
import { gql } from 'utils/ajax';
import DownloadContainer from 'containers/DownloadContainer';
import { DataValidationTable } from 'components/Tables';
import Icon from 'components/UIKit/Icon/Icon';

class DataValidation extends Component {
  static propTypes = {
    router: PropTypes.any,
    projects: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      dataValidationReport: []
    };
  }

  componentDidMount = () => {
    this.setState(this.buildReport(this.props, this.state));
  };

  getDerivedStateFromProps = (props, state) => {
    return this.buildReport(props, state);
  };

  buildQuery = ({ project_id: projectId }) => {
    return {
      variables: {
        projectId: projectId || null,
      },
      query: `query DataValidationQuery(
        $projectId: [String]
      ) {
        fileSizeFail: _submitted_file_count (
          error_type:"file_size"
          state:"invalid"
          project_id: $projectId
        )
        fileFormatFail: _submitted_file_count (
          error_type:"file_format"
          state:"invalid"
          project_id: $projectId
        )
        md5sumFail: _submitted_file_count (
          error_type:"md5sum"
          state:"invalid"
          project_id: $projectId
        )
        filesValidated: _submitted_file_count (
          state:"validated"
          project_id: $projectId
        )
      }`
    };
  };

  buildReport = ({
    router: {
      params: { program, project }
    },
    projects: projectsBeforeFilter,
  }, state) => {
    let updatedState;
    if (projectsBeforeFilter.length > 0) {
      let projects = program && project
        ? projectsBeforeFilter.filter(x =>
          x.project_id.indexOf(program) > -1 &&
          x.project_id.indexOf(project) > -1
        )
        : projectsBeforeFilter;

      projects.forEach(async (p) => {
        let { data } = await gql(this.buildQuery(p));
        let [ program, ...project ] = p.project_id.split(`-`);
        let { dbgap_accession_number } = p;

        updatedState = {
          dataValidationReport: [
            ...state.dataValidationReport,
            {
              program, project: project.join(`-`),
              dbgap_accession_number, ...data
            }
          ]
        };
      });
    }

    return updatedState;
  };

  render() {
    let { dataValidationReport } = this.state;

    let {
      router: {
        params: { program, project }
      }
    } = this.props;

    return (
      <div style={{ width: `100%` }}>
         <div
          style={{
            display: `flex`,
            flexDirection: `row-reverse`,
            padding: `1rem 2rem`
          }}
        >
          <DownloadContainer
            body={ dataValidationReport.length ? toTsvString(dataValidationReport) : `` }
            format="TSV"
            filename={
              `data-validation-report_${program && project ? `${program}-${project}` : ``}`
            + `_${moment().toISOString()}.tsv`
            }
            style={{ display: `flex`, alignItems: `center`, cursor: `pointer` }}
          >
            <Icon>file_download</Icon>
            <span>Download Report</span>
          </DownloadContainer>
        </div>
        <DataValidationTable
          report={ dataValidationReport }
        />
      </div>
    );
  }
}

export default connect(
  ({
    router,
    projects: {
      items: projects
    }
  }) => ({
    router,
    projects,
  })
)(DataValidation);
